/* Result extras on the humanizer and detector pages: the inline sign-in
   strips (.si-bar, guests), the thumbs under the result (everyone) and the
   share prompt that follows a thumbs-up. Every hook quietly does nothing
   when its markup is absent.

   Page scripts drive it through events on window:
     'upsell:start'                  — a run was started by the user; the
                      strips appear now, still neutral (see below)
     'upsell:result'  {guestTextId? | userTextId? | detectorJobId?} — a run
                      finished; show the strips, arm the thumbs
     'upsell:cleared'                — keep a neutral sign-in strip; reset feedback */
(function () {
    'use strict';

    var AUTO_KEY = 'share-auto-shown';
    var BAR_KEY = 'si-bar-dismissed-at';
    var BAR_TTL = 7 * 24 * 60 * 60 * 1000;   // a week of quiet after a dismiss

    function byId(id) { return document.getElementById(id); }

    /* ---------------------------------------------------------------- strips */

    var barTop = byId('signInBar') || byId('detectorSignInBar');
    var barMid = byId('signInBarMid');
    var strips = [barTop, barMid].filter(Boolean);

    /* the cross means "not now": the strip stays away for the next runs too,
       for a week, instead of popping back on every result */
    function barDismissed() {
        try {
            var at = Number(localStorage.getItem(BAR_KEY) || 0);
            return at > 0 && Date.now() - at < BAR_TTL;
        } catch (e) { return false; }
    }
    strips.forEach(function (bar) {
        var close = byId(bar.id + 'Close');
        if (close) close.addEventListener('click', function () {
            bar.hidden = true;
            /* top and mid are the same strip in two placements — dismissing
               one dismisses the pair, or it pops back at another breakpoint */
            if (bar === barTop && barMid) barMid.hidden = true;
            if (bar === barMid && barTop) barTop.hidden = true;
            try { localStorage.setItem(BAR_KEY, String(Date.now())); } catch (e) {}
        });
    });

    function showResultBars() {
        if (barDismissed()) return;
        strips.forEach(function (bar) {
            bar.classList.remove('is-idle', 'is-pending');
            bar.hidden = false;
        });
    }

    /* Hovering (or focusing) the sign-in link ramps the colour drift up 4×.
       The playbackRate is tweened, not switched, so there is no jump; the
       animation itself lives in CSS (si-bar-drift). */
    (function () {
        if (!strips.length) return;
        var rate = 1, target = 1, raf = null;
        function anims() {
            return strips
                .filter(function (el) { return !el.hidden && el.getAnimations; })
                .map(function (el) { return el.getAnimations()[0]; })
                .filter(Boolean);
        }
        function tick() {
            rate += (target - rate) * 0.12;
            if (Math.abs(target - rate) <= 0.02) { rate = target; raf = null; }
            else raf = requestAnimationFrame(tick);
            anims().forEach(function (a) { a.playbackRate = rate; });
        }
        function to(v) {
            target = v;
            if (!raf) raf = requestAnimationFrame(tick);
        }
        strips.forEach(function (el) {
            var link = el.querySelector('.si-bar-link');
            if (!link) return;
            link.addEventListener('mouseenter', function () { to(4); });
            link.addEventListener('mouseleave', function () { to(1); });
            link.addEventListener('focus', function () { to(4); });
            link.addEventListener('blur', function () { to(1); });
        });
    })();

    /* ------------------------------------------------- thumbs + share prompt */

    var rate = byId('feedbackRate');
    var note = byId('feedbackNote');
    var shPop = byId('sharePop');
    var shBack = byId('shareBack');

    var guestTextId = null;    // the finished run's id in its own table
    /* which table that id points into: 'guest' (guest_texts), 'user'
       (user_texts) or 'detector' (ai_detector_jobs, uuid, both audiences) */
    var textKind = 'guest';
    var choice = null;
    var shareUrl = null;       // 24h link for the current result, once fetched
    var shareUrlPromise = null;
    var shareUrlVariant = null; // which take the fetched link points at

    /* The humanizer may answer with two takes; the tabs live in data_q.js.
       Reading the DOM instead of listening avoids any event-order coupling. */
    function currentVariant() {
        var tab = document.querySelector('.variant-bar .variant-tab.active');
        if (!tab) return 1;
        return Array.prototype.indexOf.call(tab.parentNode.children, tab) + 1;
    }

    function autoShown() {
        try { return localStorage.getItem(AUTO_KEY) === '1'; } catch (e) { return false; }
    }
    function markAutoShown() {
        try { localStorage.setItem(AUTO_KEY, '1'); } catch (e) {}
    }

    function send(url, body) {
        return (window.csrfFetch || window.fetch)(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify(body)
        });
    }

    /* --- share prompt (modal presentation only) --- */

    var shHide;
    function shareOpen() {
        return !!shPop && !shPop.hidden && shPop.classList.contains('show');
    }
    /* The Trustpilot "Review Collector" TrustBox (partial/share-modal) is
       Trustpilot's iframe, drawn by their bootstrap script. The script comes
       in the first time the prompt opens, not with every page: a third-party
       request on every load, for a box most visits never see. The bootstrap
       renders every .trustpilot-widget it finds when it runs; loadFromElement
       covers a box it missed (the prompt is in the DOM from the start, so
       normally it does not). */
    function loadTrustpilot() {
        var box = shPop.querySelector('.trustpilot-widget');
        if (!box || box.dataset.tpLoaded) return;
        box.dataset.tpLoaded = '1';
        var mount = function () {
            if (window.Trustpilot && !box.querySelector('iframe')) window.Trustpilot.loadFromElement(box, true);
        };
        if (window.Trustpilot) { mount(); return; }
        var script = document.createElement('script');
        script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
        script.async = true;
        script.onload = mount;
        document.head.appendChild(script);
    }

    function openShare() {
        if (!shPop) return;
        clearTimeout(shHide);
        shPop.hidden = false;
        shBack.hidden = false;
        loadTrustpilot();
        /* a forced reflow instead of requestAnimationFrame: rAF stalls in
           background tabs, leaving an invisible prompt that still eats clicks */
        void shPop.offsetWidth;
        shPop.classList.add('show');
        shBack.classList.add('show');
        /* The 24h link is minted only when "Copy link" is pressed: fetching it
           on open filled the table with links nobody asked for — every first
           thumbs-up created one. If the clipboard refuses the late write, the
           copy handler falls back to showing the link in a prompt. */
    }
    function closeShare() {
        if (!shPop) return;
        shPop.classList.remove('show');
        shBack.classList.remove('show');
        clearTimeout(shHide);
        shHide = setTimeout(function () {
            shPop.hidden = true;
            shBack.hidden = true;
        }, 200);
    }
    /* dismissing is the signal: never auto-open again, the footer link remains */
    function dismissShare() {
        markAutoShown();
        closeShare();
    }

    function ensureShareUrl() {
        /* result links are a signed-in feature: a guest's text stays their
           own (their chips share the tool itself, and no copy chip renders) */
        if (!shPop || !guestTextId || textKind !== 'user' || !shPop.dataset.shareEndpoint) return Promise.resolve(null);
        var variant = currentVariant();
        /* switching takes repoints the link server-side, so a cached URL is
           only good for the take it was minted for */
        if (shareUrl && shareUrlVariant === variant) return Promise.resolve(shareUrl);
        if (!shareUrlPromise || shareUrlVariant !== variant) {
            shareUrlVariant = variant;
            shareUrlPromise = send(shPop.dataset.shareEndpoint, { user_text_id: guestTextId, variant: variant })
                .then(function (res) { return res.ok ? res.json() : null; })
                .then(function (data) {
                    var url = data && data.url ? data.url : null;
                    /* a slower response for a take no longer on screen must
                       not overwrite the current one */
                    if (shareUrlVariant === variant) shareUrl = url;
                    return url;
                })
                .catch(function () {
                    if (shareUrlVariant === variant) shareUrlPromise = null;
                    return null;
                });
        }
        return shareUrlPromise;
    }

    function flashChip(el, label) {
        var l = el.querySelector('.sh-item-l');
        if (!l) return;
        var was = l.textContent;
        el.classList.add('is-done');
        l.textContent = label;
        setTimeout(function () {
            l.textContent = was;
            el.classList.remove('is-done');
        }, 2000);
    }

    if (shPop) {
        byId('sharePopClose').addEventListener('click', dismissShare);
        shBack.addEventListener('click', dismissShare);
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && shareOpen()) dismissShare();
        });

        /* actions never close the prompt — sharing one place should not end the moment */
        shPop.addEventListener('click', function (e) {
            var chip = e.target.closest('[data-share]');
            if (!chip) return;
            if (chip.dataset.share === 'copy') {
                ensureShareUrl().then(function (url) {
                    /* signed-in: the 24h link to this result; guests (whose
                       texts are never published) hand a friend the tool */
                    var link = url || shPop.dataset.siteUrl;
                    if (!link) return;
                    var write = navigator.clipboard && navigator.clipboard.writeText
                        ? navigator.clipboard.writeText(link)
                        : Promise.reject();
                    write.then(function () {
                        flashChip(chip, shPop.dataset.doneCopied);
                    }).catch(function () {
                        /* clipboard refused outside the gesture: show the link
                           itself so it can still be copied by hand */
                        window.prompt(shPop.dataset.doneCopied, link);
                    });
                });
                return;
            }
            if (chip.dataset.shareUrl) {
                window.open(chip.dataset.shareUrl, '_blank', 'noopener');
                flashChip(chip, shPop.dataset.doneOpened);
            }
        });
    }

    /* --- thumbs --- */

    function renderNote() {
        if (!note) return;
        if (!choice) { note.hidden = true; return; }
        var lead = note.querySelector('.fb-note-lead');
        var link = note.querySelector('.fb-note-link');
        lead.textContent = choice === 'up' ? note.dataset.upLead : note.dataset.downLead;
        link.textContent = choice === 'up' ? note.dataset.upLink : note.dataset.downLink;
        /* the thumbs-down link opens the contact form with this result's
           reference prefilled, so support can look the text up */
        var contactUrl = note.dataset.contactUrl || '#';
        /* signed-in only: a guest's report must not advertise that their text
           kept a findable id — same privacy stance as the share link */
        if (choice === 'down' && guestTextId && textKind === 'user' && note.dataset.reportPrefill && contactUrl !== '#') {
            contactUrl += (contactUrl.indexOf('?') === -1 ? '?' : '&')
                + 'topic=' + encodeURIComponent('Technical Support')
                + '&message=' + encodeURIComponent(note.dataset.reportPrefill.replace(':id', guestTextId));
        }
        link.setAttribute('href', choice === 'up' ? '#' : contactUrl);
        note.hidden = false;
    }

    function resetFeedback() {
        choice = null;
        guestTextId = null;
        textKind = 'guest';
        shareUrl = null;
        shareUrlPromise = null;
        shareUrlVariant = null;
        if (rate) {
            rate.hidden = true;
            rate.querySelectorAll('.fb-btn').forEach(function (b) {
                b.setAttribute('aria-pressed', 'false');
            });
        }
        renderNote();
        closeShare();
    }

    if (rate && note) {
        rate.addEventListener('click', function (e) {
            var btn = e.target.closest('.fb-btn');
            if (!btn) return;
            /* clicking the active thumb un-presses it and clears the line */
            var next = btn.getAttribute('aria-pressed') === 'true' ? null : btn.dataset.fb;
            choice = next;
            rate.querySelectorAll('.fb-btn').forEach(function (b) {
                b.setAttribute('aria-pressed', String(b.dataset.fb === next && next !== null));
            });
            renderNote();
            if (guestTextId) {
                var body = textKind === 'detector'
                    ? { job_id: guestTextId, rating: next }
                    : { rating: next, variant: currentVariant() };
                if (textKind === 'guest') body.guest_text_id = guestTextId;
                if (textKind === 'user') body.user_text_id = guestTextId;
                send(rate.dataset.feedbackEndpoint, body).catch(function () {});
            }
            closeShare();
            if (next === 'up' && !autoShown()) {
                openShare();
                markAutoShown();
            }
        });

        /* the note link: permanent share entry after a thumbs-up; after a
           thumbs-down it is a plain link to the contact form */
        note.querySelector('.fb-note-link').addEventListener('click', function (e) {
            if (choice !== 'up') return;
            e.preventDefault();
            if (shareOpen()) closeShare();
            else openShare();
        });
    }

    /* ------------------------------------------------------------- wiring */

    window.addEventListener('upsell:result', function (e) {
        var d = e.detail || {};
        textKind = d.detectorJobId ? 'detector' : (d.guestTextId ? 'guest' : 'user');
        guestTextId = d.detectorJobId || d.guestTextId || d.userTextId || null;
        choice = null;
        shareUrl = null;
        shareUrlPromise = null;
        shareUrlVariant = null;
        if (rate) {
            rate.hidden = false;
            rate.querySelectorAll('.fb-btn').forEach(function (b) {
                b.setAttribute('aria-pressed', 'false');
            });
        }
        renderNote();
        showResultBars();
    });

    /* The strips change the layout: on phones the pinned strip pushes the
       hero down by its height (async.css), on desktop it adds a row to the
       controls. Done when the result lands, that move happens seconds after
       the last tap and Chrome counts it as a layout shift (field CLS 0.4-0.7
       on the tool pages, Oct 2026). On the stacked layouts the strip is
       revealed on the start tap, inside the input grace window, pending: it
       keeps its room but is invisible (async.css), and the result only
       switches it on. Desktop shows it with the result and takes the row it
       adds then - a small shift, chosen over a row standing empty through
       the run (Oct 2026 review). A strip still up from the last result stays
       up through the next run: only the reader's close takes it away. */
    window.addEventListener('upsell:start', function () {
        if (barDismissed()) return;
        if (!window.matchMedia('(max-width: 900px)').matches) return;
        strips.forEach(function (bar) {
            if (!bar.hidden) return;
            bar.classList.add('is-idle', 'is-pending');
            bar.hidden = false;
        });
    });

    window.addEventListener('upsell:cleared', function () {
        /* Keep the sign-in invitation in place without claiming a result is
           ready while the pane is empty or another run is in progress. */
        strips.forEach(function (bar) {
            bar.classList.add('is-idle');
            bar.classList.remove('is-pending');
        });
        resetFeedback();
    });
})();
